import React from 'react';
import { Grid } from '@material-ui/core';
import { SanlamOrange } from 'Material-UI/colors';
import { IntlShape, injectIntl } from 'react-intl';
import {
  BodyContainer,
  AbsoluteGrid,
  StyledMediumSectionHeader,
} from 'containers/LexiquePage/styles';
import { useSelector } from 'react-redux';
import { Lexique } from 'translations/lexique';
import messages from 'containers/LexiquePage/messages';
import { translate } from 'helpers/intl';
import { getLocaleSelector } from 'store/LanguageProvider/selectors';
import { get } from 'lodash';
import ScrollBack from 'components/ButtonBackToTop';
const Body = (props: { intl: IntlShape }) => {
  const lang = useSelector(getLocaleSelector);
  return (
    <Grid container alignItems="center" justify="center">
      <BodyContainer>
        <AbsoluteGrid>
          <ScrollBack showBelow={1200} />
          <Grid container alignItems="center" justify="center">
            <Grid item xs>
              <StyledMediumSectionHeader weight="400">
                {translate(get(messages, 'description_lexique'), props)}
              </StyledMediumSectionHeader>
              {get(Lexique, lang).map(
                (items: {
                  Alphab: string;
                  words: { title: string; description: string }[];
                }) => (
                  <>
                    <StyledMediumSectionHeader
                      weight="500"
                      color={SanlamOrange}
                    >
                      {items.Alphab}
                    </StyledMediumSectionHeader>
                    {items.words.map(
                      (item: { title: string; description: string }) => (
                        <StyledMediumSectionHeader weight="100">
                          <strong>{item.title}</strong>
                          {item.description}
                        </StyledMediumSectionHeader>
                      ),
                    )}
                  </>
                ),
              )}
            </Grid>
          </Grid>
        </AbsoluteGrid>
      </BodyContainer>
    </Grid>
  );
};
export default injectIntl(Body);
